import {useCallback} from 'react';
import useTypedSelector from '../common/useTypedSelector';
import {handleLoginPageweb} from './handleLoginPageweb.function';

export function useLogin() {
  const userData = useTypedSelector(state => state.user);

  const doLogin = useCallback((returnUrl?: string) => {
    handleLoginPageweb({callbackUrl: returnUrl});
  }, []);

  return {
    isLogin: !!userData.user,
    user: userData.user,
    doLogin,
  };
}
